<template>
  <div>
    <div class="container">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="药材列表" name="1">
          <div
            style="
            width: 100%;
            display: flex;
          "
          >
            <el-form
              :inline="true"
              :model="meridiansFormInline"
              class="demo-form-inline"
            >
              <el-form-item label="药材名：">
                <el-input v-model="meridiansFormInline.keyword"></el-input>
              </el-form-item>
            </el-form>
            <el-button
              style="width: 56px;height: 32px;"
              type="primary"
              @click="search(1)"
              >查询</el-button
            >
          </div>
          <div class="title">
            <div>药材列表</div>
            <div>
              <el-button type="primary" @click="add(1)">新增药材</el-button>
              <el-button type="primary" @click="outportData()">导出</el-button>
            </div>
          </div>
          <el-table
            :data="tableData"
            class="table"
            header-cell-class-name="table-header"
            v-loading="loading"
          >
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="药名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="spy"
              label="首字母简拼"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="xpy"
              label="全拼码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="aliases"
              label="别名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="about"
              label="相关药材（开方中替换）"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="unit"
              label="单位"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="spec"
              label="单位重量(g)"
              align="center"
            ></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status">已下架</span>
                <span v-else>已上架</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="edit(scope.row, 1)"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="del(scope.row, 1)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination" v-if="totalPages > 1">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="currentPage"
              :page-size="page_size"
              :page-count="totalPages"
              @current-change="handlePageChange"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="配伍禁忌" name="2">
          <div
            style="
            width: 100%;
            display: flex;
          "
          >
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item label="药材名：">
                <el-input v-model="formInline.title"></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-select v-model="formInline.meridiansRule">
                  <el-option
                    v-for="item in meridiansRule"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-button
              style="width: 56px;height: 32px;"
              type="primary"
              @click="search(2)"
              >查询</el-button
            >
          </div>
          <!-- 标题 -->
          <div class="title">
            <div>配伍禁忌列表</div>
            <div>
              <el-button type="primary" @click="add(2)">新增药材</el-button>
            </div>
          </div>
          <el-table :data="pwData" style="width: 100%" v-loading="loading">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="shmedicines_id"
              label="药材ID1"
              align="center"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="药材1"
              align="center"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="taboo_shmedicines_id"
              label="药材ID2"
              align="center"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="taboo_name"
              label="药材2"
              align="center"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="rule"
              label="禁忌规则"
              align="center"
              width="200"
            >
            </el-table-column>
            <el-table-column prop="rule_name" label="违规处理" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="edit(scope.row, 2)"
                  icon="el-icon-edit"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  @click="del(scope.row, 2)"
                  icon="el-icon-delete"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.is_shelf == 1"
                  @click="isShelf(scope.row)"
                  >下架</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.is_shelf == 0"
                  @click="isShelf(scope.row)"
                  >上架</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination" v-if="pwjj_totalPages > 1">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="pwjj_currentPage"
              :page-size="pwjj_page_size"
              :page-count="pwjj_totalPages"
              @current-change="handlePwjjPageChange"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 药材列表弹出框 -->
    <el-dialog
      :visible.sync="medicinesVisible"
      width="40%"
      :close-on-click-modal="false"
      v-if="this.activeName == '1' && this.activeName1 == '1-1'"
    >
      <el-form
        :model="medicinesForm"
        label-width="120px"
        :rules="medicinesRules"
        ref="ruleForm"
      >
        <el-form-item label="药材名称：" prop="name">
          <el-input
            v-model="medicinesForm.name"
            type="text"
            placeholder="请填写药材名称"
            show-word-limit
            >*</el-input
          >
        </el-form-item>
        <el-form-item label="药材编号：" v-if="is_add == false">
          <el-input
            v-model="uuid"
            disabled
            type="text"
            show-word-limit
            >*</el-input
          >
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位：" prop="unit">
              <el-select v-model="medicinesForm.unit">
                <el-option
                  v-for="item in unitList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位重量(g)：" prop="spec">
              <el-input
                v-model="medicinesForm.spec"
                type="text"
                placeholder="请填写单位重量"
                show-word-limit
                >*</el-input
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="最大用量：" prop="max_count">
              <el-input
                v-model="medicinesForm.max_count"
                type="text"
                placeholder="请填写最大用量"
                show-word-limit
                >*</el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="超量处理：" prop="out_process">
              <el-select v-model="medicinesForm.out_process">
                <el-option
                  v-for="item in out_process"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="用法建议：" prop="usage_proposal">
          <el-select v-model="medicinesForm.usage_proposal">
            <el-option
              v-for="item in usage_proposal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="全拼码：" prop="xpy">
          <el-input
            v-model="medicinesForm.xpy"
            type="text"
            placeholder="请填写全拼码"
            show-word-limit
            >*</el-input
          >
        </el-form-item>
        <div style="padding:5px 20px 20px">
          <div class="border"></div>
        </div>
        <el-form-item label="别名：" prop="aliases">
          <el-input
            v-model="medicinesForm.aliases"
            type="text"
            placeholder="请填写别名"
            show-word-limit
            >*</el-input
          >
        </el-form-item>
        <el-form-item label="相关药材：" prop="about">
          <!-- <el-input
            v-model="medicinesForm.about"
            type="text"
            placeholder="请填写相关药材"
            show-word-limit
            >*</el-input
          > -->

          <el-select
            ref="option_about"
            v-model="medicinesForm.about"
            filterable
            multiple
            remote
            reserve-keyword
            placeholder="请填写相关药材"
            :remote-method="remoteMethod2"
            @change="selectChange($event)"
          >
            <el-option
              v-for="item in options2"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="medicinesForm.remark"
            type="textarea"
            placeholder="请填写备注"
            show-word-limit
            >*</el-input
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm', 1)"
          >保 存</el-button
        >

        <el-button type="primary" @click="medicinesVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!-- 配伍禁忌弹出框 -->
    <el-dialog
      :visible.sync="pwjjVisible"
      width="40%"
      :title="editTitle"
      center
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="药材名称1：" prop="shmedicines_name">
              <!-- <el-input
                v-model="form.shmedicines_name"
                type="text"
                placeholder="请填写药材名称1"
                style="width: 240px"
                show-word-limit
                >*</el-input
              > -->
              <!-- <el-autocomplete
                v-model="state"
                :fetch-suggestions="querySearchAsync"
                placeholder="请填写药材名称1"
                @select="handleSelect"
                @input="handleInput($event)"
              ></el-autocomplete> -->
              <el-select
                ref="option_shmedicines_name"
                v-model="form.shmedicines_name"
                filterable
                remote
                reserve-keyword
                placeholder="请填写药材名称1"
                :remote-method="remoteMethod"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="药材名称2：" prop="to_shmedicines_name">
              <el-select
                ref="option_to_shmedicines_name"
                v-model="form.to_shmedicines_name"
                filterable
                remote
                reserve-keyword
                placeholder="请填写药材名称2"
                :remote-method="remoteMethod1"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="禁忌规则：">
          <el-select v-model="form.rule">
            <el-option
              v-for="item in ruleData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="违规处理：">
          <el-select v-model="form.rule_type">
            <el-option
              v-for="item in rule_type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm', 2)"
          >保 存</el-button
        >
        <el-button type="primary" @click="pwjjVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/dorisApiConfig";
import { exportShmedicineApi } from "../../../../network/url";
// import VUE_APP_API_DORIS_URL from "../../../api/getapi/doris";
// import $ from "jquery";
export default {
  name: "medicinemaintenance",
  data() {
    return {
      options: [],
      list: [],
      states: [],
      options1: [],
      list1: [],
      states1: [],
      options2: [],
      list2: [],
      states2: [],
      restaurants: [],
      timeout: null,
      is_add: true,
      keyword: "",
      medicinesVisible: false,
      pwjjVisible: false,
      editTitle: "",
      activeName: "1",
      activeName1: "1-1",
      loading: false,
      father_class: [{ label: "无", value: 0 }],
      formInline: {
        meridiansRule: "全部",
      },
      meridiansFormInline: {},
      uuid:"",
      medicinesForm: {},
      bencaoForm: {},
      tableData: [],
      pwData: [],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      //   分页
      pwjj_currentPage: 1,
      pwjj_totalPages: 1,
      pwjj_page_size: 10,
      pwjj_pageTotal: 10,
      pwjj_page_index: 10,
      //   excel
      excelData: [],
      excel_current: 1,
      excel_totals: 1,
      form: {
        shmedicines_name: "",
        to_shmedicines_name: "",
        rule: "十八反",
        rule_type: 1,
      },
      form1: {},
      meridiansRule: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "十八反",
          label: "十八反",
        },
        {
          value: "十九畏",
          label: "十九畏",
        },
      ],
      unitType: [],
      ruleData: [
        {
          value: "十八反",
          label: "十八反",
        },
        {
          value: "十九畏",
          label: "十九畏",
        },
      ],
      rule_type: [
        {
          value: 1,
          label: "提醒",
        },
        {
          value: 2,
          label: "禁止",
        },
      ],
      unitList: [
        {
          value: "g",
          label: "g",
        },
        {
          value: "克",
          label: "克",
        },
        {
          value: "条",
          label: "条",
        },
        {
          value: "个",
          label: "个",
        },
        {
          value: "颗",
          label: "颗",
        },
        {
          value: "袋",
          label: "袋",
        },
        {
          value: "瓶",
          label: "瓶",
        },
        {
          value: "盒",
          label: "盒",
        },
        {
          value: "箱",
          label: "箱",
        },
        {
          value: "根",
          label: "根",
        },
        {
          value: "片",
          label: "片",
        },
        {
          value: "枚",
          label: "枚",
        },
      ],
      out_process: [
        {
          value: 1,
          label: "提醒",
        },
        {
          value: 2,
          label: "禁止",
        },
      ],
      usage_proposal: [
        {
          value: "先煎",
          label: "先煎",
        },
        {
          value: "后下",
          label: "后下",
        },
        {
          value: "单包",
          label: "单包",
        },
        {
          value: "冲服",
          label: "冲服",
        },
        {
          value: "包煎",
          label: "包煎",
        },
        {
          value: "烊化兑服",
          label: "烊化兑服",
        },
        {
          value: "另炖",
          label: "另炖",
        },
        {
          value: "打碎",
          label: "打碎",
        },
        {
          value: "无",
          label: "无",
        },
      ],
      status: [
        {
          value: "0",
          label: "已上架",
        },
        {
          value: "1",
          label: "已下架",
        },
      ],

      rules: {
        shmedicines_name: [
          { required: true, message: "请填写药材名称1", trigger: "blur" },
        ],
        to_shmedicines_name: [
          { required: true, message: "请选择药材名称2", trigger: "blur" },
        ],
      },
      medicinesRules: {
        name: [{ required: true, message: "请填写药材名称", trigger: "blur" }],
        unit: [{ required: true, message: "请填写单位", trigger: "blur" }],
        spec: [{ required: true, message: "请选择单位重量", trigger: "blur" }],
      },
      shmedicines_name: "",
      to_shmedicines_name: "",
      about: "",
    };
  },
  created() {
    this.getData();
    this.getDataPwjj();
    // this.loadAll();
    this.list = this.states.map((item) => {
      return { id: `id:${item}`, name: `name:${item}` };
    });
    this.list1 = this.states1.map((item) => {
      return { id: `id:${item}`, name: `name:${item}` };
    });
    this.list2 = this.states2.map((item) => {
      return { id: `id:${item}`, name: `name:${item}` };
    });
  },
  methods: {
    selectChange(val) {
      this.medicinesForm.dataName = []; //初始化数据
      for (let i = 0; i <= val.length - 1; i++) {
        this.options2.find((item) => {
          //这里的options就是数据源
          if (item.id == val[i]) {
            this.medicinesForm.dataName.push(item.name); //这里的label我改成了name
          }
        });
      }
      this.medicinesForm.dataName = this.medicinesForm.dataName.join(); //转字符串
    },
    remoteMethod(query) {
      if (query !== "") {
        let that = this;
        let params = {
          keyword: query,
        };
        that.shmedicines_name = query;
        http.get("admin/sh_medicines/select", { params }).then(function(res) {
          if (res.data.status_code == 200) {
            that.options = res.data.data;
          }
        });
      } else {
        let that = this;
        that.options = [];
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        let that = this;
        let params = {
          keyword: query,
        };
        that.to_shmedicines_name = query;
        http.get("admin/sh_medicines/select", { params }).then(function(res) {
          if (res.data.status_code == 200) {
            that.options1 = res.data.data;
          }
        });
      } else {
        let that = this;
        that.options1 = [];
      }
    },
    remoteMethod2(query) {
      if (query !== "") {
        let that = this;
        let params = {
          keyword: query,
        };
        that.about = query;
        http.get("admin/sh_medicines/select", { params }).then(function(res) {
          if (res.data.status_code == 200) {
            that.options2 = res.data.data;
          }
        });
      } else {
        let that = this;
        that.options2 = [];
      }
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
        keyword: that.meridiansFormInline.keyword,
      };
      http.get("admin/sh_medicines", { params: params }).then(function(res) {
        if (res.data.status_code == 200) {
          http.get("admin/sh_medicines/select").then(function(res) {
            if (res.data.status_code == 200) {
              that.options2 = res.data.data;
            }
          });
          that.tableData = res.data.data.medicines;
          that.currentPage = res.data.data.current_page;
          that.totalPages = parseInt(res.data.data.total_pages);
          that.loading = false;
        }
      });
    },
    getDataPwjj() {
      let that = this;
      that.loading = true;
      let params = {
        keyword: that.formInline.title,
        rule:
          that.formInline.meridiansRule == "全部"
            ? ""
            : that.formInline.meridiansRule,
        page: that.pwjj_currentPage,
        page_size: that.pwjj_page_size,
      };
      http.get("admin/taboos", { params: params }).then(function(res) {
        that.pwData = res.data.data.taboos;
        that.pwjj_currentPage = res.data.data.current_page;
        that.pwjj_totalPages = parseInt(res.data.data.total_pages);
        that.loading = false;
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handlePwjjPageChange(val) {
      this.pwjj_currentPage = val;
      this.getDataPwjj();
    },
    // 搜索
    search(type) {
      if (type == 1) {
        this.currentPage = 1;
        this.getData();
      } else if (type == 2) {
        this.pwjj_currentPage = 1;
        this.getDataPwjj();
      }
    },
    // 新增
    add(type) {
      if (type == 1) {
        this.medicinesForm = {};
        this.medicinesVisible = true;
        this.is_add = true;
      } else {
        this.form = {};
        this.pwjjVisible = true;
        this.is_add = true;
      }
    },
    // 编辑
    edit(row, type) {
      if (type == 1) {
        this.editTitle = "药材详情页";
        this.is_add = false;
        this.medicinesVisible = true;
        this.medicinesForm = {
          medicine_id: row.medicine_id,
          name: row.name,
          unit: row.unit,
          spec: row.spec,
          aliases: row.aliases,
          xpy: row.xpy,
          about: row.about_ids,
          max_count: row.max_count,
          out_process: row.out_process,
          usage_proposal: row.usage_proposal,
          remark: row.remark,
        };
        this.uuid = row.uuid;
        this.selectChange(this.medicinesForm.about);
      } else {
        this.editTitle = "配伍禁忌详情页";
        this.is_add = false;
        this.form = {
          shmedicines_name: row.name,
          to_shmedicines_name: row.taboo_name,
          rule: row.rule,
          rule_type: row.rule_name == "提醒" ? 1 : 2,
          id: row.id,
        };
        this.pwjjVisible = true;
      }
    },
    saveEdit(formName, type) {
      if (type == 1) {
        if (this.is_add) {
          this.medicinesForm.about = this.medicinesForm.dataName;
          if (this.medicinesForm.dataName) {
            delete this.medicinesForm.dataName;
          }
          let that = this;
          that.loading = true;
          that.$refs[formName].validate((valid) => {
            if (valid) {
              http
                .post("admin/sh_medicine", that.medicinesForm)
                .then(function(res) {
                  if (res.data.status_code == 200) {
                    that.$message.success("新增成功");
                    that.medicinesVisible = false;
                    that.getData();
                    that.loading = false;
                  } else {
                    that.loading = false;
                    that.$message.error(res.data.msg);
                  }
                });
            } else {
              return false;
            }
          });
        } else {
          this.medicinesForm.about = this.medicinesForm.dataName;
          if (this.medicinesForm.dataName) {
            delete this.medicinesForm.dataName;
          }
          let that = this;
          that.loading = true;
          that.$refs[formName].validate((valid) => {
            if (valid) {
              http
                .put("admin/sh_medicine", that.medicinesForm)
                .then(function(res) {
                  if (res.data.status_code == 200) {
                    that.$message.success("修改成功");
                    that.medicinesVisible = false;
                    that.getData();
                    that.loading = false;
                  } else {
                    that.loading = false;
                    that.$message.error(res.data.msg);
                  }
                });
            } else {
              return false;
            }
          });
        }
      } else {
        if (this.is_add) {
          this.form.shmedicines_name = this.$refs.option_shmedicines_name.selected.label;
          this.form.to_shmedicines_name = this.$refs.option_to_shmedicines_name.selected.label;
          let that = this;
          that.loading = true;
          that.$refs[formName].validate((valid) => {
            if (valid) {
              http.post("admin/taboo", that.form).then(function(res) {
                if (res.data.status_code == 200) {
                  that.$message.success("新增成功");
                  that.pwjjVisible = false;
                  that.getDataPwjj();
                  that.loading = false;
                } else {
                  that.loading = false;
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              return false;
            }
          });
        } else {
          this.form.shmedicines_name = this.$refs.option_shmedicines_name.selected.label;
          this.form.to_shmedicines_name = this.$refs.option_to_shmedicines_name.selected.label;
          let that = this;
          that.loading = true;
          that.$refs[formName].validate((valid) => {
            if (valid) {
              http.put("admin/taboo", that.form).then(function(res) {
                if (res.data.status_code == 200) {
                  that.$message.success("修改成功");
                  that.pwjjVisible = false;
                  that.getDataPwjj();
                  that.loading = false;
                } else {
                  that.loading = false;
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              return false;
            }
          });
        }
      }
    },
    // 删除
    del(row, type) {
      if (type == 1) {
        let that = this;
        // 二次确认删除
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            let params = {
              medicine_id: row.medicine_id,
            };
            http
              .delete("admin/sh_medicine", { params: params })
              .then(function(res) {
                if (res.data.status_code == 200) {
                  that.$message.success("删除成功");
                  that.getData();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {});
      } else {
        let that = this;
        // 二次确认删除
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            let params = {
              id: row.id,
            };
            http.delete("admin/taboo", { params: params }).then(function(res) {
              if (res.data.status_code == 200) {
                that.$message.success("删除成功");
                that.getDataPwjj();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 导出
    // 导出药材列表 请求第一页
    outportData() {
      exportShmedicineApi().then((res) => {
        // 将文件流转成blob形式
        const blob = new Blob([res.data], {
          type: "application/octet-stream;charset=utf-8",
        });
        // const blob = res.data;
        let filename = "excel" + ".xls";
        // 创建一个超链接，将文件流赋进去，然后实现这个超链接的单击事件
        const elink = document.createElement("a");
        elink.download = filename;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      });
    },
    // 选项卡
    handleClick(e) {
      console.log(e.index, "e");
      if (e.index == 0) {
        this.getData();
      } else {
        this.getDataPwjj();
      }
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    // 上下架
    // statusEdit(row, type) {
    //   if (type == 0) {
    //     let that = this;
    //     // 二次确认删除
    //     that
    //       .$confirm("确定要下架吗？", "提示", {
    //         type: "warning",
    //       })
    //       .then(() => {
    //         let params = {
    //           medicine_id: row.medicine_id,
    //           status: 1,
    //         };
    //         http.post("admin/medicine/status", params).then(function(res) {
    //           // console.log(res);
    //           if (res.data.status_code == 200) {
    //             that.$message.success("下架成功");
    //             that.getData();
    //           } else {
    //             that.$message.error(res.data.msg);
    //           }
    //         });
    //       })
    //       .catch(() => {});
    //   } else {
    //     let that = this;
    //     // 二次确认删除
    //     that
    //       .$confirm("确定要上架吗", "提示", {
    //         type: "warning",
    //       })
    //       .then(() => {
    //         let params = {
    //           medicine_id: row.medicine_id,
    //           status: 0,
    //         };
    //         http.post("admin/medicine/status", params).then(function(res) {
    //           // console.log(res);
    //           if (res.data.status_code == 200) {
    //             that.$message.success("上架成功");
    //             that.getData();
    //           } else {
    //             that.$message.error(res.data.msg);
    //           }
    //         });
    //       })
    //       .catch(() => {});
    //   }
    // },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.handle-input {
  width: 300px;
  display: inline-block;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 20px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.border {
  width: 100%;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgb(121, 121, 121) 0%,
    rgb(121, 121, 121) 40%,
    transparent 50%
  );
  background-size: 20px 2px;
  background-repeat: repeat-x;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/#tab-1-2 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
